<template>
  <div class="menu__user" :class="{ 'menu__user--open': isOpenMenu }">
    <img v-if="user.avatar" :src="user.avatar" alt="Аватар пользотеля" class="menu__avatar" />
    <button v-else @click="$emit('login')">
      <svg-icon name="default-avatar" class="menu__avatar" />
      <span>Войти</span>
      <svg-icon name="sign-in" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'UserMenu',
  props: {
    user: {
      type: Object,
      default: () => ({})
    },

    isOpenMenu: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.menu {
  &__user {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;

    button {
      width: 100%;
      display: flex;
      align-items: center;

      span {
        font-weight: bold;
        font-size: 15px;
        margin-left: 8px;
        color: $luchmara;
        flex: 1;
        display: flex;
      }

      svg:last-of-type,
      span {
        visibility: hidden;
        opacity: 0;
        transition: 0.3s;
      }

      svg:last-of-type {
        stroke: $luchmara;
        width: 32px;
      }

      &:hover {
        opacity: 0.6;
      }
    }

    &--open {
      justify-content: normal;

      svg:last-of-type,
      span {
        visibility: visible !important;
        opacity: 1 !important;
      }
    }
  }

  &__avatar {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    margin-left: 4px;
  }

  &--open &__avatar {
    margin-left: 0;
  }
}
</style>
